export default `float de(vec3 p){
    float r = 1; 
    return length(p) - r;
  }`